export function generatePdfFileName( user, language, keywords ) {

    const firstName = user?.firstName || user?.prenom || 'NoFirstName';
    const lastName = user?.lastName?.toUpperCase() || user?.nom?.toUpperCase() || 'NoLastName';
    const lang = language?.toUpperCase() || 'NoLang'
    const keyw = keywords?.join( '_' ) || 'NoKeyWords';

    return `ACO_${ firstName }_${ lastName }_CV_${ lang }_${ keyw }.pdf`;
}

